import { render, staticRenderFns } from "./b4-login-modal.vue?vue&type=template&id=1a6fb3e0&"
import script from "./b4-login-modal.vue?vue&type=script&lang=ts&"
export * from "./b4-login-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\projects\\git\\b4\\b4-marketing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1a6fb3e0', component.options)
    } else {
      api.reload('1a6fb3e0', component.options)
    }
    module.hot.accept("./b4-login-modal.vue?vue&type=template&id=1a6fb3e0&", function () {
      api.rerender('1a6fb3e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "source/scripts/components/login/b4-login-modal.vue"
export default component.exports